module.exports = __webpack_public_path__ + "static/media/25.2ea70f62.jpg";